import styled from "styled-components";

const Wrapper = styled.div`
  padding: 30px 50px 0;
`;

const ProgressWrap = styled.div`
  position: relative;
  padding-top: 20px;
  margin-bottom: 20px;
`;

const ProgressBar = styled.div`
  height: 3px;
  background: #eee;
  border-radius: 2px;
`;

const ProgressFill = styled.div`
  height: 100%;
  width: ${({ $width }) => `${$width}%`};
  background: #333;
  border-radius: 2px;
`;

const ProgressLabel = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  font-size: 13px;
  font-weight: 500;
`;

const OtpFlowTitle = styled.h2`
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 8px;
  @media (max-width: 481px) {
    font-size: 20px;
  }
`;

const OtpFlowSubText = styled.p`
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 20px;
`;

export {
  Wrapper,
  ProgressBar,
  ProgressFill,
  ProgressWrap,
  OtpFlowTitle,
  ProgressLabel,
  OtpFlowSubText
};
